// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .node {
    margin: 10px;
} */

.RenderChildNodes__sortSource___gznXD {
    font-weight: bold;
    background: orange;
    color: black;
    padding: 3px;
    border-radius: 5px;
}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sortSource": `RenderChildNodes__sortSource___gznXD`
};
module.exports = ___CSS_LOADER_EXPORT___;
